import React from "react";
import "../Component/Component.css/NotificationSlider.css";

const notifications = [
  { text: "ग्रामसभा दिनांक 15 नोव्हेंबर 2025 रोजी आयोजित करण्यात आली आहे", color: "#2883E5" },
  { text: "स्वच्छ भारत अभियान अंतर्गत स्वच्छता मोहीम सुरु", color: "#E5287A" },
  { text: "गावातील पाणीपुरवठा देखभाल कामामुळे 2 दिवस बंद – 5 व 6 नोव्हेंबर", color: "#28AFE5" }, // fixed color
  { text: "जल जीवन मिशन योजना अर्ज सादर करण्याची शेवटची तारीख – 10 डिसेंबर 2024", color: "#E528B6" },
  { text: "जल जीवन मिशन योजना अर्ज सादर करण्याची शेवटची तारीख – 10 डिसेंबर 2025", color: "#E5282B" },
  { text: "ग्रामसभा दिनांक 15 नोव्हेंबर 2025 रोजी आयोजित करण्यात आली आहे", color: "#2883E5" },
];

const NotificationSlider = () => {
  return (
    <div className="notification-slider-wrapper">
      <div className="notification-slider">
        {/* Duplicate notifications for seamless infinite scroll */}
        {[...notifications, ...notifications].map((note, i) => (
          <div
            key={i}
            className="notification"
            style={{ backgroundColor: note.color }}
          >
            {note.text}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationSlider;
